import ApplicationRecord from '@/models/application_record'

import {
  Model,
  Attr
} from 'spraypaint'

@Model()
export default class Tenant extends ApplicationRecord {
  static jsonapiType = 'tenants'

  @Attr name!: string
}
